$(function(){
	if($("section.accordionCoronita").length > 0){
		$(".accordionCoronita-item-title").click(function(){
			if ($(this).parent().parent().hasClass("activeAccordion")){

				$(this).parent().parent().removeClass("activeAccordion");
				$(this).parent().parent().find(".accordionCoronita-item-answer").css({"max-height": "1px", "min-height": "1px"});
			}
			else {
				$(".accordionCoronita-item.activeAccordion").find(".accordionCoronita-item-answer").css({"max-height": "1px", "min-height": "1px"});
				$(".accordionCoronita-item").removeClass("activeAccordion");
				$(this).parent().parent().addClass("activeAccordion");
				var heightAccordionQuestion = $(this).parent().parent().find(".accordionCoronita-item-answer-container").innerHeight();
				$(this).parent().parent().find(".accordionCoronita-item-answer").css({"max-height": heightAccordionQuestion, "min-height": heightAccordionQuestion});
			}

			if ($(".accordionCoronita-item.activeAccordion").length > 0){
				setTimeout(function(){ 
					$('html, body').animate({
						scrollTop: $(".accordionCoronita-item.activeAccordion").offset().top
					}, 300);
				 }, 400);
			}
			else{
				$('html, body').animate({
					scrollTop: $("section.accordionCoronita").offset().top
				}, 300);
			}
		})
	}
})